const MONTHS = {
		0: 'January',
		1: 'February',
		2: 'March',
		3: 'April',
		4: 'May',
		5: 'June',
		6: 'July',
		7: 'August',
		8: 'September',
		9: 'October',
		10: 'November',
		11: 'December'
}

const SHORT_MONTHS = {
		'January': 'Jan',
		'February': 'Feb',
		'March': 'Mar',
		'April': 'Apr',
		'May': 'May',
		'June': 'Jun',
		'July': 'Jul',
		'August': 'Aug',
		'September': 'Sep',
		'October': 'Oct',
		'November': 'Nov',
		'December': 'Dec'
}

const DAYS = {
	0: 'Sun',
	1: 'Mon',
	2: 'Tue',
	3: 'Wed',
	4: 'Thu',
	5: 'Fri',
	6: 'Sat'
}

export { SHORT_MONTHS, MONTHS, DAYS }
